import { render, staticRenderFns } from "./sign_up.vue?vue&type=template&id=134023d0&scoped=true"
import script from "./sign_up.vue?vue&type=script&lang=js"
export * from "./sign_up.vue?vue&type=script&lang=js"
import style0 from "./sign_up.vue?vue&type=style&index=0&id=134023d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134023d0",
  null
  
)

export default component.exports